import firebase from "firebase/compat/app"
import "firebase/compat/messaging"

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD6ZCm6zsKtBvX_ZeogqWBawdEZfn8QdsA",
  authDomain: "padhai-chat.firebaseapp.com",
  projectId: "padhai-chat",
  storageBucket: "padhai-chat.appspot.com",
  messagingSenderId: "50961287602",
  appId: "1:50961287602:web:a9ca61872a489ee239fcab",
  measurementId: "G-M5XM35Q3Z0",
}

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}
const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null

// Check if service worker is registered and return it
const getServiceWorkerRegistration = async () => {
  if ("serviceWorker" in navigator) {
    try {
      // Check for existing registration
      const existingReg = await navigator.serviceWorker.getRegistration("/firebase-messaging-sw.js")
      if (existingReg) {
        console.log("Found existing service worker registration")
        return existingReg
      }

      // Register new service worker
      const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
        scope: "/",
      })
      console.log("Service Worker registered successfully with scope:", registration.scope)
      return registration
    } catch (error) {
      console.error("Error registering service worker:", error)
      return null
    }
  } else {
    console.warn("Service workers are not supported in this browser")
    return null
  }
}

// Function to get FCM token
export const getFCMToken = async () => {
  try {
    // Check if notification permission is granted
    if (Notification.permission !== "granted") {
      const permission = await Notification.requestPermission()
      if (permission !== "granted") {
        console.log("Notification permission denied")
        return null
      }
    }

    // Get service worker registration
    const serviceWorkerRegistration = await getServiceWorkerRegistration()
    if (!serviceWorkerRegistration) {
      throw new Error("Service worker registration failed")
    }

    // Get FCM token
    const currentToken = await messaging.getToken({
      vapidKey: "BMeFqKDNr08nTY15uuVfSUvCkvdsMbCLitBJ_71POxc5hcptu69Z23BX_HIOwsD_1QY2eHngRwfBkjvmohFI9B8",
      serviceWorkerRegistration,
    })

    if (currentToken) {
      console.log("FCM Token obtained:", currentToken)
      return currentToken
    } else {
      console.log("No registration token available")
      return null
    }
  } catch (error) {
    console.error("Error getting FCM token:", error)
    return null
  }
}

// Function to delete FCM token
export const deleteFCMToken = async () => {
  try {
    await messaging.deleteToken()
    console.log("FCM token deleted successfully")
    return true
  } catch (error) {
    console.error("Error deleting FCM token:", error)
    return false
  }
}

// Replace the saveTokenToServer function with this new implementation
export const saveTokenToServer = async (userId, token) => {
  try {
    if (!userId || !token) {
      console.error("Missing userId or token")
      return false
    }

    console.log(`Saving token for user ${userId} using dedicated Lambda function`)

    // Use the dedicated Lambda function URL
    const response = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request: "savetoken",
        body: {
          pid: userId,
          token: token,
        },
      }),
    })

    if (!response.ok) {
      console.error(`Error response from server: ${response.status} ${response.statusText}`)
      return false
    }

    const data = await response.json()
    console.log("Token save response:", data)

    if (data.success) {
      console.log("Token saved successfully")
      return true
    } else {
      console.error("Failed to save token:", data.error || "Unknown error")
      return false
    }
  } catch (error) {
    console.error("Error saving token to server:", error)

    // Retry once after a short delay
    try {
      console.log("Retrying token save after error...")
      await new Promise((resolve) => setTimeout(resolve, 2000))

      const retryResponse = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          request: "savetoken",
          body: {
            pid: userId,
            token: token,
          },
        }),
      })

      if (retryResponse.ok) {
        const retryData = await retryResponse.json()
        if (retryData.success) {
          console.log("Token saved successfully on retry")
          return true
        }
      }
    } catch (retryError) {
      console.error("Retry also failed:", retryError)
    }

    return false
  }
}

// Replace the removeTokenFromServer function with this new implementation
export const removeTokenFromServer = async (userId, token) => {
  try {
    if (!userId) {
      console.error("Missing userId")
      return false
    }

    console.log(`Removing token for user ${userId}`)

    const response = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request: "deletetoken",
        body: {
          pid: userId,
        },
      }),
    })

    if (!response.ok) {
      console.error(`Error response from server: ${response.status} ${response.statusText}`)
      return false
    }

    const data = await response.json()
    console.log("Token removal response:", data)

    if (data.deletedCount >= 0) {
      console.log(`Successfully removed ${data.deletedCount} tokens`)
      return true
    } else {
      console.error("Failed to remove token:", data.error || "Unknown error")
      return false
    }
  } catch (error) {
    console.error("Error removing token from server:", error)
    return false
  }
}

// Replace the checkTokenOnServer function with this new implementation
export const checkTokenOnServer = async (userId) => {
  try {
    if (!userId) {
      console.error("Missing userId")
      return { exists: false }
    }

    console.log(`Checking token for user ${userId}`)

    const response = await fetch("https://tvaf32pm2tarajmrxaxyy3pp3e0zgjyx.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request: "checktoken",
        body: {
          pid: userId,
        },
      }),
    })

    if (!response.ok) {
      console.error(`Error response from server: ${response.status} ${response.statusText}`)
      return { exists: false }
    }

    const data = await response.json()
    console.log("Token check response:", data)

    return {
      exists: data.hasToken,
      token: data.token,
    }
  } catch (error) {
    console.error("Error checking token on server:", error)
    return { exists: false }
  }
}

// Add the setupMessageHandler function after the checkTokenOnServer function

// Set up message handler for Firebase Cloud Messaging
export const setupMessageHandler = (callback) => {
  try {
    if (!messaging) {
      console.error("Firebase messaging is not initialized")
      return () => {}
    }

    // Set up the onMessage handler for foreground messages
    const unsubscribe = messaging.onMessage((payload) => {
      console.log("Message received in foreground:", payload)

      // Call the callback function with the payload
      if (callback && typeof callback === "function") {
        callback(payload)
      }

      // Always show a notification for important messages when in foreground
      if (payload.notification && Notification.permission === "granted") {
        const { title, body } = payload.notification
        new Notification(title, {
          body,
          icon: "/notification-icon.png",
          data: payload.data,
        })
      }
    })

    console.log("Message handler set up successfully")
    return unsubscribe
  } catch (error) {
    console.error("Error setting up message handler:", error)
    return () => {}
  }
}

// Add the initializeFirebaseMessaging function after the setupMessageHandler function

// Initialize Firebase messaging
export const initializeFirebaseMessaging = async () => {
  try {
    // Get user ID from localStorage
    const teacherData = localStorage.getItem("teacherData")
    if (!teacherData) {
      console.log("No user data found in localStorage")
      return null
    }

    const userData = JSON.parse(teacherData)
    if (!userData || !userData._id) {
      console.log("Invalid user data in localStorage")
      return null
    }

    const userId = userData._id

    // Get FCM token
    const token = await getFCMToken()

    if (token) {
      // Save token to localStorage
      localStorage.setItem("fcmToken", token)

      // Save token to server
      await saveTokenToServer(userId, token)

      // Set up message handler
      setupMessageHandler((payload) => {
        console.log("Global message handler received:", payload)
      })
    }

    return token
  } catch (error) {
    console.error("Error initializing Firebase messaging:", error)
    return null
  }
}
